/// <reference path="_references.ts"/>

module App.Forms {
	import Appointment = App.Appointments.Appointment;

	export class FormListController {
		static $inject: string[] = [
			'$scope', '$state', 'ToastService', 'OfficeService', 'SelectedAppointment', 'TitleBarService', 'FormService'
		];

		public isLoading: boolean = true;

		protected appointment: Appointment;
		public instances: FormInstanceList[] = [];

		constructor(
			protected $scope: ng.IScope,
			protected $state: ng.ui.IStateService,
			protected ToastService: App.Utils.ToastService,
			protected OfficeService: App.Utils.OfficeService,
			protected SelectedAppointment: App.Appointments.SelectedAppointment,
			protected TitleBarService: App.Helpers.TitleBarService,
			protected FormService: FormService
		) {
			TitleBarService.set('Forms');

			OfficeService.getAppointment()
				.then((resp) => resp.data)
				.catch(() => SelectedAppointment.getAppointment())
				.then((appt) => {
					if (!appt) {
						throw '';
					}

					this.appointment = appt;

					return this.FormService.getInstances(appt.service_request.id);
				})
				.then((response) => {
					this.instances = response.data;
					if (!this.instances || this.instances.length < 1) {
						this.$state.go('.create');
					} else {
						this.isLoading = false;
					}
				})
				.catch((err) => {
					this.ToastService.showError('Error loading forms: ', err);
					this.$state.go('home');
				});
		}
	}
}
